
  import { mapEntityProperties } from '@/utils/mapEntityProperties'
  import { RegionEntity } from '../../domain/entities/RegionEntity'
  export class RegionModel extends RegionEntity {
  constructor(dataDto) {
    super()
    mapEntityProperties(this, dataDto)
  }
}